import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import PropTypes from 'prop-types'

const DndProviderWrapper = ({ children }) => {
  return <DndProvider backend={HTML5Backend}>{children}</DndProvider>
}

DndProviderWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}

export default DndProviderWrapper
